import React, { useEffect, useRef, useState } from "react";
import images from "../../../assets/images/constantImages";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import TotalRevenue from "./TotalRevenue";
import apiService, {
  formatRupees,
  handleError,
} from "../../Common/ApiCommon/ApiService";
import icons from "../../../assets/images/constantIcons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

const DashboardCards = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const menuRef = useRef(null);
  const [transactions, setTransactions] = useState({});
  const [selectedFilter, setSelectedFilter] = useState("today");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isCustomDateOpen, setIsCustomDateOpen] = useState(false);
  const [TransactionHidden, setTransactionHidden] = useState(true);

  const formatDate = (date) => {
    if (!date) return null;
    return date.toString(); // Returns full date string with timezone
  };

  const openDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const getDateRange = (filter) => {
    const today = new Date();
    let fromDate, toDate;

    if (filter === "today") {
      fromDate = toDate = today;
    } else if (filter === "yesterday") {
      fromDate = new Date(today);
      fromDate.setDate(today.getDate() - 1);
      toDate = new Date(today);
      toDate.setDate(today.getDate() - 1);
    } else if (filter === "weekly") {
      fromDate = new Date(today);
      fromDate.setDate(today.getDate() - 7);
      toDate = today;
    } else if (filter === "monthly") {
      fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
      toDate = today;
    }

    return {
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
    };
  };

  // Fetch transactions data
  const fetchDashboardData = async () => {
    try {
      let filterQuery = "";
      let start_date = fromDate;
      let end_date = toDate;

      if (
        selectedFilter === "today" ||
        selectedFilter === "weekly" ||
        selectedFilter === "monthly" ||
        selectedFilter === "yesterday"
      ) {
        const range = getDateRange(selectedFilter);
        start_date = range.fromDate;
        end_date = range.toDate;
      } else if (selectedFilter === "custom" && fromDate && toDate) {
        start_date = formatDate(fromDate);
        end_date = formatDate(toDate);
      }

      filterQuery = `&filter=${selectedFilter}&start_date=${start_date}&end_date=${end_date}`;
      const response = await apiService.get(`/dashboards?${filterQuery}`);
      setTransactions(response.transactions);
    } catch (errors) {
      handleError(errors);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, [selectedFilter, fromDate, toDate]);

  const handleFilterChange = (filter) => {
    if (filter === "custom") {
      setIsCustomDateOpen((prev) => !prev);
    } else {
      setSelectedFilter(filter.toLowerCase());
      setDropdownOpen(false);
    }
  };

  const applyFilter = () => {
    if (fromDate && toDate) {
      setSelectedFilter("custom");
    }
    setDropdownOpen(false);
    setIsCustomDateOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const transactioncard = [
    {
      background: "bg-purple",
      heading: "Cash",
      price: formatRupees(transactions.cash || 0),
      imageicon: images.cash,
    },
    {
      background: "bg-pink",
      heading: "Card",
      price: formatRupees(transactions.card || 0),
      imageicon: images.card,
    },
    {
      background: "bg-blue",
      heading: "UPI",
      price: formatRupees(transactions.upi || 0),
      imageicon: images.upi,
    },
    {
      background: "bg-orange",
      heading: "Due",
      price: formatRupees(transactions.due || 0),
      imageicon: images.prime,
    },
  ];

  const percentCard = [
    {
      imagepercent: images.percent,
      heading: "Discount",
      rupee: formatRupees(transactions.discount || 0),
    },
    {
      imagepercent: images.wallet,
      heading: "Collection",
      rupee: formatRupees(transactions.credit || 0),
    },
  ];

  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        <h1 className="text-xl sm:text-2xl xl:text-[30px] text-G800 font-semibold mb-3">
          Dashboard
        </h1>
        <div className="relative" ref={menuRef}>
          <button
            onClick={openDropdown}
            className="bg-green700 w-10 h-10 flex items-center justify-center rounded-lg mb-3"
          >
            <img
              src={images.dashboardsetttingicon}
              className="w-5 h-5"
              alt="dashboardsetttingicon"
            />
          </button>

          {dropdownOpen && (
            <div className="absolute right-2 bg-white shadow-md w-[250px] px-4 py-2  z-40 rounded-2xl">
              <div className="flex justify-between items-center border-b py-1 mb-2">
                <p className="text-base font-medium">Filter</p>
                <div
                  className="cursor-pointer"
                  onClick={() => setDropdownOpen(false)}
                >
                  <icons.IoClose className="text-green700" />
                </div>
              </div>
              <div className="flex justify-between items-center px-2 py-2 hover:bg-green50 cursor-pointer text-G500 " onClick={() => handleFilterChange("")}>
                <span className="text-sm">All</span>
              </div>
              {["yesterday", "weekly", "monthly"].map((filter) => (
                <p key={filter}
                  className={`text-sm p-2 rounded-md cursor-pointer hover:bg-green50 ${selectedFilter === filter ? "text-green font-semibold" : " text-G500"
                    }`} onClick={() => handleFilterChange(filter)}>
                  {filter.charAt(0).toUpperCase() + filter.slice(1)}
                </p>
              ))}
              <div
                className={`flex justify-between items-center px-2 py-2 hover:bg-green50 cursor-pointer ${selectedFilter === "custom"
                  ? "text-green font-semibold"
                  : " text-G500"
                  }`}
                onClick={() => handleFilterChange("custom")}
              >
                <span className="text-sm">Custom Date</span>
                <icons.MdOutlineCalendarMonth className="text-green700" />
              </div>
              {isCustomDateOpen && (
                <div className="p-2">
                  <DatePicker
                    selected={fromDate}
                    onChange={setFromDate}
                    selectsStart
                    startDate={fromDate}
                    endDate={toDate}
                    placeholderText="From Date"
                    className="text-G500 placeholder:text-xs border px-3 py-1 rounded w-full mb-2 text-sm outline-none"
                    dateFormat="yyyy-MM-dd"
                  />
                  <DatePicker
                    selected={toDate}
                    onChange={setToDate}
                    selectsEnd
                    startDate={fromDate}
                    endDate={toDate}
                    minDate={fromDate}
                    placeholderText="To Date"
                    className="text-G500 placeholder:text-xs border px-3 py-1 rounded w-full text-sm outline-none"
                    dateFormat="yyyy-MM-dd"
                  />
                  <div className="flex justify-between mt-2">
                    <button
                      className="border border-green hover:bg-green hover:text-white text-green  py-1 rounded-md w-[75px] text-sm text-center"
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                        setIsDropdownOpen(false);
                        setIsCustomDateOpen(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={applyFilter}
                      className="border border-green text-green hover:bg-green hover:text-white py-1 rounded-md w-[75px] text-sm text-center"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}

              <div
                className="flex justify-between items-center px-2 py-2 hover:bg-green50 cursor-pointer text-G500 "
                onClick={() => handleFilterChange("today")}
              >
                <span className="text-sm">Clear Filters</span>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-col-3 md:grid-cols-4 gap-3 md:gap-0">
        <div className="md:col-span-3">
          <div
            className="bg-white rounded-2xl p-2 xs:p-4 md:p-3 xl:p-5 md:mr-3 h-auto md:h-[230px] lg:h-[250px] xl:h-[280px]"
            style={{ boxShadow: "1px 17px 44px 0px #A8A5A51A" }}
          >
            <div className="flex items-center justify-between mb-2">
              <h1 className="text-heading text-lg sm:text-xl xl:text-2xl">
                {(() => {
                  const today = new Date();
                  const format = (date) =>
                    date?.toLocaleDateString("en-GB", { year: "numeric", month: "short", day: "numeric" });

                  let title = "All ";
                  let dateRange = "";

                  switch (selectedFilter) {
                    case "today":
                      title = "Today ";
                      dateRange = `(${format(today)})`;
                      break;
                        case "yesterday":
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    title = "Yesterday ";
    dateRange = `(${format(yesterday)})`;
    break;
                    case "weekly":
                      const weekStart = new Date();
                      weekStart.setDate(today.getDate() - 7);
                      title = "Weekly ";
                      dateRange = `(${format(weekStart)} - ${format(today)})`;
                      break;
                    case "monthly":
                      const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
                      title = "Monthly ";
                      dateRange = `(${format(monthStart)} - ${format(today)})`;
                      break;
                    case "custom":
                      if (fromDate && toDate) {
                        title = "Custom ";
                        dateRange = `(${format(new Date(fromDate))} - ${format(new Date(toDate))})`;
                      }
                      break;
                  }

                  return (
                    <>
                      <span className="text-indigo font-semibold">{title}</span>
                      <span>Transactions</span>
                      <span className="text-sm text-gray-500 font-normal pl-2">{dateRange}</span>
                    </>
                  );
                })()}
              </h1>

              <button
                onClick={() => setTransactionHidden((prev) => !prev)}
                className="text-gray-500 hover:text-gray-800"
                title={
                  TransactionHidden ? "Show Transactions" : "Hide Transactions"
                }
              >
                {TransactionHidden ? (
                  <FaRegEyeSlash className="w-7 h-7 text-green" />
                ) : (
                  <FaRegEye className="w-7 h-7 text-green" />
                )}
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 pt-3 gap-4">
              <div className="grid grid-cols-2 gap-3 sm:gap-5 md:gap-3 xl:gap-5">
                {transactioncard.map((card, index) => (
                  <div
                    key={index}
                    className={`relative flex items-center justify-between rounded-2xl p-2 xs:p-4 md:p-2 ${card.background}`}
                  >
                    <div className="flex flex-col text-white">
                      <h1 className="text-sm xl:text-base">{card.heading}</h1>
                      <div className="relative group">
                        <p className="truncate max-w-[120px] text-base xl:text-xl font-semibold ">
                          {TransactionHidden ? "••••••" : card.price}
                        </p>

                        {card.price.replace(/[^\d]/g, "").length >= 6 && (
                          <div className="absolute bottom-full mb-1 left-1/2 transform -translate-x-1/2 scale-0 group-hover:scale-100 transition-all bg-black text-white font-medium text-base px-2 py-1 rounded whitespace-nowrap z-50">
                            {TransactionHidden ? "••••••" : card.price}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="xl:w-[45px] xl:h-[45px] w-[35px] h-[35px] bg-white flex justify-center items-center rounded-xl">
                      <img
                        src={card.imageicon}
                        alt="transactionlogo"
                        className="xl:w-[25px] xl:h-[25px] lg:w-[20px] lg:h-[20px] sx:h-[20px] sx:w-[20px]"
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-2 gap-5 md:gap-2 lg:gap-4">
                {percentCard.map((data, index) => (
                  <div
                    className="bg-green50 rounded-2xl flex flex-col items-center justify-center p-3"
                    key={index}
                  >
                    <div className="w-[60px] h-[60px] lg:w-[80px] lg:h-[80px] xl:w-[89px] xl:h-[89px] relative z-20 ">
                      <CircularProgressbarWithChildren
                        value={66}
                        styles={buildStyles({
                          strokeWidth: "60px",
                          pathColor: "url(#gradient)",
                          trailColor: "#fff",
                          width: "89px",
                          height: "89px",
                        })}
                      >
                        <svg height="0" width="0">
                          <defs>
                            <linearGradient
                              id="gradient"
                              x1="0%"
                              y1="0%"
                              x2="100%"
                              y2="100%"
                            >
                              <stop
                                offset="6.27%"
                                style={{ stopColor: "#025B1B", stopOpacity: 1 }}
                              />
                              <stop
                                offset="63.47%"
                                style={{ stopColor: "#13A63B", stopOpacity: 1 }}
                              />
                              <stop
                                offset="108.41%"
                                style={{ stopColor: "#13A63B", stopOpacity: 1 }}
                              />
                            </linearGradient>
                          </defs>
                        </svg>
                        <img
                          className="w-[24px] h-[24px]"
                          src={data.imagepercent}
                          alt="percent"
                        />
                      </CircularProgressbarWithChildren>
                      <div className="">
                        <img
                          className="absolute top-0 -right-[3px] rotate-3 -z-10"
                          src={images.transactionpath1}
                          alt="percent"
                        />
                        <img
                          className="absolute w-[50px] -right-[4px] lg:w-[70px] xl:w-auto top-[20px] lg:top-[18px] xl:top-[23px] lg:-right-[10px]  rotate-10 -z-10"
                          src={images.transactionpath2}
                          alt="percent"
                        />
                      </div>
                    </div>
                    <h1 className="text-green text-sm lg:text-base font-medium mt-3">
                      {data.heading}
                    </h1>
                    <div className="relative group">
                      <p className="truncate max-w-[150px] text-G800 text-xl xl:text-2xl font-medium">
                        {TransactionHidden ? "••••••" : data.rupee}
                      </p>

                      {data.rupee.replace(/[^\d]/g, "").length >= 7 && (
                        <div className="absolute bottom-full mb-1 left-1/2 transform -translate-x-1/2 scale-0 group-hover:scale-100 transition-all bg-black text-white font-medium text-base px-2 py-1 rounded whitespace-nowrap z-50">
                          {TransactionHidden ? "••••••" : data.rupee}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <TotalRevenue transactions={transactions} />
      </div>
    </div>
  );
};

export default DashboardCards;
